export const AngleDownIcon = (): JSX.Element => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.219168 0.375342C0.564178 -0.0559202 1.19347 -0.125842 1.62473 0.219168L6.00004 3.71941L10.3753 0.219168C10.8066 -0.125842 11.4359 -0.0559202 11.7809 0.375342C12.1259 0.806604 12.056 1.4359 11.6247 1.78091L6.62473 5.78091C6.25951 6.07308 5.74056 6.07308 5.37534 5.78091L0.375342 1.78091C-0.0559202 1.4359 -0.125842 0.806604 0.219168 0.375342Z"
      fill="#333333"
    />
  </svg>
);
